import React from "react";

const TopCoinUkPolicy = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between">
          <div className="col-lg-12">
                              <p className="text-dark fw-semibold opacity-50 mb-0">
              Effective Date: 10/08/2025
            </p>
            <p className="text-dark fw-semibold opacity-50 mb-0">
              Company: TopCoin UK. Ltd
            </p>
             <p className="text-dark fw-semibold opacity-50 mb-0">
             Company Registeration No: 16483297
            </p>
            <p className="text-dark fw-semibold opacity-50 mb-3">
              Contact: info@topcoinuk.com
            </p>
            <h5 className="text-dark opacity-75">Issued by: Topcoin UK Ltd.</h5>
            <h6 className="text-dark opacity-75">1. Purpose and Scope</h6>
            <p className="text-dark opacity-50">
              This policy governs the global operations of Topcoin UK (TCUK), a
              customer rewards and business advertising system. As TCUK expands
              internationally, this policy ensures that all customers,
              businesses, and partners understand the purpose, structure, and
              operational framework of TCUK in every region.
            </p>
            <div>
              <h6 className="text-dark opacity-75">
                2. TCUK Global Operating Principles
              </h6>
              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Topcoin UK is not a cryptocurrency, investment scheme, or
                  gambling platform.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  The system is designed to reward customers with free TopCoin 
                  when they make purchases at participating businesses.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  These TopCoins unlock increasing levels of customer cash rewards,
                  encouraging continued engagement and brand loyalty.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TCUK works globally using local partnerships, while the
                  central value system remains managed and standardized by
                  Topcoin UK Ltd (UK HQ).
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">
                3. TCUK System (Global Version)
              </h6>
              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Customers receive free TCUK with every eligible
                  purchase.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TopCoins are stored in six TopCoin Wallets. As more TopCoins
                  accumulate, wallets unlock in sequence.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  With progress, customers also unlock seven Cash Wallets, each
                  tied to a Topcoin UK Coin.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  The 8th and final Coin is known as the Eternity TopCoin,
                  linked to the Eternity Cash Wallet, representing the ultimate
                  loyalty milestone.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TopCoins are not tradable, not purchasable, and do not act as
                  currency or financial products. They measure engagement and
                  loyalty only.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  All coins, including the Eternity Coin, must be earned through
                  activity within the TCUK ecosystem.
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">
                4. Business Participation Policy
              </h6>
              <p className="mb-1 text-dark opacity-50 fw-semibold ps-3">
                Requirements for Global Businesses:
              </p>
              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Must register and agree to the TCUK Business Agreement.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Pay a TopCoin issuance fee for every TopCoin given to customers
                  (based on the internal TopCoin rate).
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Receive marketing, listing on the TCUK global blockchain
                  network, and earn passive income from network-wide activity.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Businesses in each country have local blockchain branches, but
                  remain connected to the global Topcoin UK blockchain.
                </li>
              </ul>
            </div>
            <div>
              <p className="mb-1 text-dark opacity-50 fw-semibold ps-3">
                Business Benefits:
              </p>
              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Passive TopCoin accumulation when other global users spend.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Inclusion in international TCUK promotions and campaigns.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Real-time analytics and customer engagement tracking.
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">
                5. Customer Policy (Global Users)
              </h6>

              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Customers of all ages (including under 18) may participate and
                  hold TopCoin.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  No registration fees or purchases of TopCoins are allowed.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Customers can track their wallet progress via the TCUK App or
                  official partners.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TopCoin cannot be exchanged for cash directly. Cash is only
                  released through unlocked cash wallets, as a loyalty-based
                  reward.
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">6. Legal and Compliance</h6>

              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TCUK operates under UK jurisdiction and expands globally
                  through licensing and affiliate structures.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Each country’s operation must comply with local consumer
                  protection, advertising, and data privacy laws.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TCUK is not regulated by the FCA, as it does not fall under
                  investment regulation. All local offices must assess local
                  financial regulations to ensure non-investment classification.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  All money released to customers is considered a loyalty
                  reward, not an investment return.
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">
                7. Fraud Prevention & Abuse
              </h6>
              <p className="mb-1 text-dark opacity-50 fw-semibold ps-3">
                TCUK reserves the right to suspend or cancel any account engaged
                in:
              </p>
              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TopCoin manipulation or artificial inflation
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Business participation fraud
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Misrepresentation of the TCUK system
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Regular audits and blockchain integrity checks ensure
                  transparent and fair distribution.
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">
                8. Brand & Global Identity
              </h6>

              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  All regional offices must use the official TCUK branding,
                  logos, and promotional materials, with approved localization.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  The phrase “Topcoin UK – Earn While You Spend” must remain
                  prominent in all global communications.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Global expansion must be aligned with the TCUK mission
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  To reward customer loyalty and help businesses grow through
                  honest, transparent, and fair digital engagement.
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">
                9. Global Wallet Progression Standard (7 Levels)
              </h6>

              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TopCoin Wallet Estimated Internal Value Associated TopCoin Cash Wallet
                  TopCoin Cash Wallet Value
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TopCoin Wallet 1
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 2 £100 TopCoin Cash Wallet 1 (£) */}
                  TopCoin Wallet 2 TopCoin Cash Wallet 1 (£)
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 3 £1,000 TopCoin Cash Wallet 2 (£) */}
                  TopCoin Wallet 3 TopCoin Cash Wallet 2 (£)
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 4 £10,000 TopCoin Cash Wallet 3 (£) */}
                  TopCoin Wallet 4 TopCoin Cash Wallet 3 (£)
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 5 £50,000 TopCoin Cash Wallet 4 (£) */}
                  TopCoin Wallet 5 TopCoin Cash Wallet 4 (£)
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 6 £100,000 TopCoin Cash Wallet 5 (£) */}
                  TopCoin Wallet 6 TopCoin Cash Wallet 5 (£)
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 6 £100,000 TopCoin Cash Wallet 5 (£) */}
                  TopCoin Wallet 7 TopCoin Cash Wallet 6 (£)
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 6 £100,000 TopCoin Cash Wallet 5 (£) */}
                  TopCoin Wallet 8 TopCoin Cash Wallet 7 (£)
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Eternity  Wallet £100,000+ Cash Eternity Wallet */}
                  TopCoin Eternity  Wallet Cash Eternity Wallet
                  (£)
                </li>
              </ul>
            </div>
               <div>
              <h6 className="text-dark opacity-75">
               10. Final Notes
              </h6>

              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                TCUK is built to scale globally, empower consumers, and give businesses a better, smarter advertising tool.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  All global expansions must report to Topcoin UK Ltd.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                 Any dispute arising from the use of this system is subject to the jurisdiction of the country where the business or customer resides, with UK HQ acting as final arbitration if needed.
                </li>

 
              </ul>
            </div>
            {/* <p className="text-dark opacity-50">
              This policy is designed to protect the value of the TopCoin UK
              system and ensure that active, engaged users benefit from its full
              rewards — including access to cash wallets and long-term earnings.
            </p>
            <p className="text-dark opacity-50">
              We thank you for your understanding and commitment to the future
              of TopCoin UK.
            </p> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopCoinUkPolicy;
